export default __webpack_public_path__ + "static/media/history-icon.8789a4f3.svg";